module.exports = __webpack_public_path__ + "static/media/soono-survey.caca221e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soono-survey.png
// module id = 1183
// module chunks = 0